import { cn, Label, Textarea } from '@1trading/react';
import type { ComponentProps } from 'react';
import { JUSTIFICATION_MAX_LENGTH, JUSTIFICATION_MIN_LENGTH } from '@/components/dialogs/confirm-action';

interface JustificationFieldProps extends ComponentProps<typeof Textarea> {
  id: string;
  /** The justification as typed, for the character count */
  justification: string;
  /** What the justification should answer; the length bounds are added */
  prompt?: string;
  /** The field's wrapper */
  className?: string;
  textareaClassName?: string;
}

/** The audit justification every audited action asks for: a labelled textarea with its character count */
export const JustificationField = ({
  id,
  justification,
  prompt = 'Why are you performing this action?',
  className,
  textareaClassName,
  ...textareaProps
}: JustificationFieldProps) => (
  <div className={cn('flex flex-col gap-2', className)}>
    <Label htmlFor={id}>Justification (recorded in the audit log)</Label>
    <Textarea
      className={cn('min-h-24', textareaClassName)}
      id={id}
      placeholder={`${prompt} ${JUSTIFICATION_MIN_LENGTH}–${JUSTIFICATION_MAX_LENGTH} characters.`}
      {...textareaProps}
    />
    <p className="text-xs text-muted-foreground">
      {justification.trim().length}/{JUSTIFICATION_MAX_LENGTH} characters (minimum {JUSTIFICATION_MIN_LENGTH})
    </p>
  </div>
);
JustificationField.displayName = 'JustificationField';
